export default __webpack_public_path__ + "static/cover-6-b16fe1e0fdd7a9549a3e28392482b756.jpg";